import $ from 'jquery';
import page from '../../../smartpak/page';
import { tooltipProxy as tooltip } from '../../../smartpak/tooltipproxy';

const miniCart = {
    _loadResults: function(html) {
        this._$miniCart.html(html);
    },

    _addCloseClick: function() {
        this._$miniCart.one('click', '#continueShopping', (e) => {
            e.preventDefault();
            if (this._modal) {
                this._modal.close();
            }
        });
    },
    show: function(html) {
        if(!this._$miniCart){
            $('a.itemArrivalDate').each(function(index, item) {
                var $link = $(item),
                    contentDiv = $('#' + $link.data('contentid')).html();
            
                tooltip($link, {
                    content: contentDiv,
                    width: 150
                });
            });
        }
        
        this._$miniCart = $('#divPromptMiniCart');
        this._loadResults(html);
        this._addCloseClick();
        page.resolveLazyLoadedImages('#SmartPerksFreeMessageMini');
        this._modal = smartPak.ui.modal(this._$miniCart.get(0), {
            resizable: false,
            width: '830px'
        });
    }
};

export default miniCart;
